import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Contact = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Header toggleSidebar={() => setOpen(true)} />
            <Sidebar isOpen={open} close={() => setOpen(false)} />
            {/* HERO */}
            <div className="about-hero">
                <div className="about-overlay">
                    <h1>CONTACT</h1>
                    <Breadcrumb />
                </div>
            </div>

            <div className="container contact-page">

                {/* CONTACT INFO */}
                <div className="contact-info">

                    <div className="contact-card">
                        <h3>📍 Address</h3>
                        <p>NAV JEEVAN MISSION SCHOOL,</p>
                        <p>ASHISH NAGAR, SONUGHAT</p>
                        <p>DEORIA</p>
                    </div>

                    <div className="contact-card">
                        <h3>📞 Phone</h3>
                        <p>+91-9889471995, 7460906241, 9794746654</p>
                    </div>

                    <div className="contact-card">
                        <h3>✉️ Email</h3>
                        <p>njmsdeoria1@gmail.com</p>
                    </div>

                </div>

                {/* CONTACT FORM */}
                <div className="contact-form">

                    <h2>Send Us a Message</h2>

                    <input type="text" placeholder="Your Name" />
                    <input type="email" placeholder="Your Email" />

                    <textarea placeholder="Your Message"></textarea>

                    <button>Send Message</button>

                </div>


                {/* MAP */}
                <div className="contact-map">
                    <iframe
                        title="map"
                        src="https://www.google.com/maps?q=Nav+Jeevan+Mission+School+Deoria&output=embed"
                        width="100%"
                        height="300"
                        style={{ border: 0 }}
                        loading="lazy"
                    ></iframe>
                </div>

                {/* LOCATION DETAILS */}
                <div className="contact-location">

                    <h2>Location Details</h2>

                    <div className="location-table-wrap">
                        <table className="location-table">
                            <tbody>

                                <tr>
                                    <td>NEAREST BANK</td>
                                    <td>Central Bank Of India Piprachandrabhan Branch Sonda Deoria</td>
                                    <td>DISTANCE OF BANK FROM SCHOOL IN KM</td>
                                    <td>1</td>
                                </tr>

                                <tr>
                                    <td>NEAREST RAILWAY STATION</td>
                                    <td>Deoria Sadar</td>
                                    <td>DISTANCE OF RAILWAY STATION FROM SCHOOL</td>
                                    <td>6</td>
                                </tr>

                                <tr>
                                    <td>NEAREST METRO STATION</td>
                                    <td>Nill</td>
                                    <td>DISTANCE OF METRO FROM SCHOOL</td>
                                    <td>00</td>
                                </tr>

                                <tr>
                                    <td>NEAREST BUS TERMINAL</td>
                                    <td>Deoria Bus Station</td>
                                    <td>DISTANCE OF BUS TERMINAL FROM SCHOOL</td>
                                    <td>3</td>
                                </tr>

                                <tr>
                                    <td>NEAREST AIRPORT</td>
                                    <td>Gorakhpur</td>
                                    <td>DISTANCE OF AIRPORT FROM SCHOOL</td>
                                    <td>52</td>
                                </tr>

                                <tr>
                                    <td>NEAREST HOSPITAL</td>
                                    <td>Government District Hospital Deoria</td>
                                    <td>DISTANCE OF HOSPITAL FROM SCHOOL</td>
                                    <td>5</td>
                                </tr>

                                <tr>
                                    <td>NEAREST POLICE STATION</td>
                                    <td>Kotwali Deoria</td>
                                    <td>DISTANCE OF POLICE STATION FROM SCHOOL</td>
                                    <td>5</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                </div>

            </div>


            <Footer />
        </>
    );
};

export default Contact;